// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_8rIqT","Header":"_3iGNz","List":"_P0p4C","ListItem":"_2CFBC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/BaggagePaxSelectMobile/BaggagePaxSelectMobile.scss
// module id = 608
// module chunks = 0